export default __webpack_public_path__ + "static/media/premium.20a9db74.svg";